import React from 'react';
import { Text } from '@mantine/core';
import CollapsibleListField from '../../../puck/fields/CollapsibleListField';
import MediaSourceField from '../../../puck/fields/MediaSourceField';
import { plainText } from '../../../utils/richTextHtml';
import { useSelectedItemProps } from '../../../puck/fields/useSelectedItemProps';
import { useListItemReveal } from '../../../puck/fields/listItemReveal';

export default function StoryStepsField({ value, onChange }) {
  const reveal = useListItemReveal(useSelectedItemProps().selectedItem?.props?.id);
  return (
    <>
      <Text size="xs">Écrivez le titre et le texte de chaque étape directement sur la page. Ici, choisissez l’illustration de l’étape : elle s’affiche à côté du texte quand le visiteur clique sur cette étape.</Text>
      <CollapsibleListField
        reveal={reveal}
        value={value}
        onChange={onChange}
        addLabel="Ajouter une étape"
        createItem={() => ({ title: '', description: '', media: '' })}
        itemTitle={(step, index) => plainText(step.title) || `Étape ${index + 1}`}
        renderItem={(step, update) => <MediaSourceField value={step.media} onChange={(media) => update({ media })} allowEmbed={false} showPlayback={false} fieldLabel="Illustration de l’étape" />}
      />
    </>
  );
}
